"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetchResponse = void 0;
const fetch_1 = __importDefault(require("@strictsoftware/fetch"));
const btoa_lite_1 = __importDefault(require("btoa-lite"));
const isAuthorization = (auth) => { var _a; return ((_a = auth === null || auth === void 0 ? void 0 : auth.Authorization) === null || _a === void 0 ? void 0 : _a.length) > 0; };
function createAuthorizationHeader(auth) {
    if (isAuthorization(auth)) {
        return auth;
    }
    if (!(auth === null || auth === void 0 ? void 0 : auth.username) || !auth.password) {
        return undefined;
    }
    const { username, password } = auth;
    return {
        Authorization: `Basic ${(0, btoa_lite_1.default)(`${username}:${password}`)}`,
    };
}
function createFetchResponse(config = {}) {
    const { logger = console, applicationName, agent } = config;
    let injectedMockConfig;
    async function fetchResponse(serviceConfig, serviceName, options = {}) {
        const url = new URL(serviceConfig.origin);
        const { auth: credentials } = serviceConfig;
        const { searchParams, headers } = options;
        if (serviceConfig.path) {
            url.pathname = serviceConfig.path;
        }
        if (searchParams) {
            url.search = searchParams.toString();
        }
        const headersWithAuthorization = Object.assign(Object.assign({}, createAuthorizationHeader(credentials)), headers);
        if (injectedMockConfig &&
            injectedMockConfig.mockIds.length > 0 &&
            injectedMockConfig.mocksServerConfig) {
            const { mockIds, mocksServerConfig } = injectedMockConfig;
            const mockRequest = {
                originalRequest: { href: url.href, headers: headersWithAuthorization },
                serviceName,
                mockIds,
                applicationName,
            };
            const mockUrl = new URL(mocksServerConfig.baseUrl);
            mockUrl.searchParams.set('mockRequest', JSON.stringify(mockRequest));
            const requestInit = {
                headers: Object.assign({}, createAuthorizationHeader(mocksServerConfig.auth)),
                agent,
            };
            const startTime = Date.now();
            try {
                return await (0, fetch_1.default)(mockUrl.href, requestInit);
            }
            catch (error) {
                logger.error('Error while fetching data:', url.href, error);
                return;
            }
            finally {
                logger.debug(`Fetched ${serviceName} mock data from ${mockUrl.href} via ${mockRequest.originalRequest.href}: ${Date.now() - startTime}ms`);
            }
        }
        else {
            const startTime = Date.now();
            const requestInit = {
                headers: headersWithAuthorization,
                agent,
            };
            try {
                return await (0, fetch_1.default)(url.href, requestInit);
            }
            catch (error) {
                logger.error('Error while fetching data:', url.href, error);
                return;
            }
            finally {
                logger.debug(`Fetched ${serviceName} data from ${url.href}: ${Date.now() - startTime}ms`);
            }
        }
    }
    fetchResponse.injectMockConfig = (mockConfig) => {
        injectedMockConfig = mockConfig;
    };
    return fetchResponse;
}
exports.createFetchResponse = createFetchResponse;
